import { get } from 'lodash';
// import { contentPages as cK } from 'src/tools/contentModulesFieldName';
import arrayMove from 'array-move';

const useContentPageGrid = ({ form }) => {
  const handleOnModalConfirm = (value, onChange, data) => {
    const draggableId = get(data, 'draggableId');
    const nI = value.map((i) => {
      const iD = get(i, 'draggableId');
      if (iD === draggableId) {
        return { ...(i || {}), ...data };
      } else {
        return i;
      }
    });

    onChange(nI);
  };
  const handleOnAdd = (value, onChange, data) => {
    //const pc = generateNewContentPage();
    //const { pc } = ;
    onChange([...(value || []), data]);
  };
  const handleOnDelete = (value, onChange, index) => {
    const nValue = (value || []).filter((_, i) => {
      return i !== index;
    });
    onChange(nValue);
  };
  const handleOnSort = (value, onChange, from, to) => {
    const nValue = arrayMove(value || [], from, to);
    onChange(nValue);
  };
  return { handleOnModalConfirm, handleOnAdd, handleOnDelete, handleOnSort };
};
export { useContentPageGrid };
